import { useEffect, useState } from 'react';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { officeApiKeyStore } from '../../../../api/office-api-key-store';
import { projectsApiKeyStore } from '../../../../api/projects-api-key-store';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { useLoadData } from '../../../../hooks/useLoadData';
import { useSaveData } from '../../../../hooks/useSaveData';
import { ApiResponse } from '../../../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { Project } from '../../../../models/project';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { ProjectCustomGridCell } from '../../../projects/project-custom-grid-cell';
import { columns } from './projects-grid-columns';
import useDebounce from '../../../../hooks/use-debounce';
import { State } from '@progress/kendo-data-query';

interface ProjectsTabProps {
  customerID: number;
}
export const ProjectsTab = ({ customerID }: ProjectsTabProps) => {
  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Customer Details', 'Project'));

  const {
    isLoading,
    data: Projects,
    refetch,
  } = useLoadData<ApiResponse<Project[]>>(projectsApiKeyStore.getCustomerProjects(customerID));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredProjects, setFilteredProjects] = useState<Project[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredProjectList = Projects?.data?.filter((Project) =>
      Object.values(Project).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredProjects(filteredProjectList || []);
  }, [debouncedSearchTerm, Projects?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'Project',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'Project',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  // ----------------------------------------------------------------------------------------
  return (
    <SiTrackGrid
      fileTitle='customer_project'
      columns={columns}
      dataItemKey="projectID"
      // queryConfig={projectsApiKeyStore.getCustomerProjects(customerID)}
      viewRoute={(project) => `/projects/details/${project.projectID}`}
      customCell={(field) =>
        ProjectCustomGridCell({
          field,
        })
      }
      actionPermissions={{
        view: UserPermissionName.VIEW_PROJECT,
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
      // -----------------Grid Layout-------
      dataItems={filteredProjects || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
    // -----------------Grid Layout-------
    />
  );
};
